import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import {
  getObservas,
  deleteObserva,
  getObservaById,
} from "../helpers/rutaObservas";
import ModalObserva from "./ModalObserva";
import "../css/tableclientes.css";

const TableObserva = () => {
  const [observas, setObservas] = useState({
    data: {},
    loading: true,
  });

  const [observa, setObserva] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaObservas();
  }, []);

  const consultaObservas = () => {
    getObservas().then((datos) => {
      console.log("📦 Observacioes:", datos);
      setObservas({
        data: datos,
        loading: false,
      });
    });
  };

  const handleClose = () => {
    setShow(false);
    consultaObservas();
  };

  const handleShow = () => setShow(true);

  const modificaObserva = (id) => {
    getObservaById(id).then((resp) => {
      if (resp.ok) {
        setObserva(resp.observa); // ✅ ahora sí solo el objeto observa
        handleShow();
      } else {
        console.error("❌ Error al obtener observa:", resp.error);
      }
    });
  };

  const eliminarObserva = (id) => {
    const confirmar = window.confirm("¿Está seguro que desea borrar la observacion?");
    if (confirmar) {
      deleteObserva(id).then(() => {
        consultaObservas();
      });
    }
  };

  return (
    <div className="table-container">
      {!observas.loading && (
        <>
          <div className="col-12 mt-4" />
          <div>
            <Table striped bordered hover className="table-container">
              <thead>
                <tr className="header">
                  <th>Acciones</th>
                  <th>Nro</th>
                  <th className="cli">Observaciones</th>
                </tr>
              </thead>
              <tbody>
                {observas.data.observas.map((observa) =>
                  observa.activo ? (
                    <tr key={observa._id}>
                      <td>
                        <button
                          className="btn btn-primary"
                          onClick={() => modificaObserva(observa._id)}
                        >
                          <i className="fa fa-pencil-square-o" aria-hidden="true" />
                        </button>
                        <button
                          className="btn btn-danger ml-2"
                          onClick={() => eliminarObserva(observa._id)}
                        >
                          <i className="fa fa-trash-o" aria-hidden="true" />
                        </button>
                      </td>
                      <td>{observa.codobs}</td>
                      <td>{observa.observa}</td>
                    </tr>
                  ) : null
                )}
              </tbody>
            </Table>
          </div>
          <ModalObserva
            show={show}
            handleClose={handleClose}
            observa={observa}
          />
        </>
      )}
    </div>
  );
};

export default TableObserva;
